'use client'

import { Suspense, useRef, useState } from 'react'
// import MuxPlayer from '@mux/mux-player-react'
// import type { MuxPlayerRefAttributes } from '@mux/mux-player-react'
import { SanityImageAssetDocument } from 'next-sanity'
import { SanityImage } from '@otomoro/components/shared/SanityImage'
import { AppText } from '@otomoro/components/shared/AppText'
import { PlayIcon } from '@otomoro/components/icons'
import clsx from "clsx"

type Props = {
	videoData: {
		playbackId: string
		aspectRatio: string
	}
	className?: string
	placeholder?: SanityImageAssetDocument
	backgroundColor?: string
	noPadding?: boolean
	caption?: string
}

export function Video({
	className,
	videoData,
	placeholder,
	backgroundColor,
	noPadding,
	caption = '',
}: Props) {
	// const videoRef = useRef<MuxPlayerRefAttributes>(null)
	const [playing, setPlaying] = useState(false)
	const [canPlayThrough, setCanPlayThrough] = useState(false)

	// const handleClick = () => {
	// 	if (videoRef.current) {
	// 		setPlaying(true)
	// 		videoRef.current.play()
	// 	}
	// }

	const handlePause = () => {
		setPlaying(false)
	}

	const handleEnded = () => {
		setPlaying(false)
	}

	const onCanPlay = () => {
		setCanPlayThrough(true)
	}

	return (
		<div
			className={clsx(
				"",
				className,
				noPadding ? 'noPadding' : undefined,
				playing ? 'playing' : undefined
			)}
			style={{ backgroundColor }}
		>
			<div
				style={{
					aspectRatio: videoData.aspectRatio
						? `${videoData.aspectRatio.split(':')[0]} / ${videoData.aspectRatio.split(':')[1]}`
						: '16/9',
				}}
			>
				{placeholder && (
					<div className="placeholder">
						<SanityImage image={placeholder} className="placeholderImage" alt="" />
						{/* <button onClick={handleClick} className="trigger" disabled={!canPlayThrough}>
							<span className="triggerInner">
								<PlayIcon className="triggerIcon" />
								<AppText
									as="span"
									className="triggerText"
									color="white"
								>
									Play video
								</AppText>
							</span>
						</button> */}
					</div>
				)}
				{/* <Suspense fallback={null}>
					<MuxPlayer
						ref={videoRef}
						playbackId={videoData.playbackId}
						//   loading="viewport"
						onPause={handlePause}
						onEnded={handleEnded}
						onCanPlay={onCanPlay}
						metadata={{
							// video_id: "video-id-123456",
							video_title: caption,
							// viewer_user_id: "user-id-bc-789",
						}}
						streamType="on-demand"
					/>
				</Suspense> */}
			</div>
		</div>
	)
}
